import { Button } from 'Components/Buttons/Buttons';
import { Modal } from 'Components/Modal/Modal';
import { Text } from 'Components/Text/Text';
import { ICON_CLOSE } from 'Config/Icons';

export interface RoleDescriptionsModalProps {
    hideModal: () => void;
}

export const RoleDescriptionsModal = (props: RoleDescriptionsModalProps) => {
    return (
        <Modal open header="Role Descriptions">
            <Text>ADMIN: Grants access to all features, including company-wide settings and user management.</Text>
            <Text>CONTROL USER: Grants access to the "Control Automation" module.</Text>
            <Text>CONTROL USER (READ-ONLY): Grants read-only access to the "Control Automation" module.</Text>
            <Text>REPORTING USER: Grants access to the "Reporting and Exports" module.</Text>
            <Text>RISK MANAGER: Grants access to the "Risk Management" module, including the "Risk Review" feature.</Text>
            <Text>RISK MANAGER (READ-ONLY): Grants read-only access to the "Risk Management" module, including the "Risk Review" feature.</Text>
            <Text>RISK USER: Grants access to the "Risk Management" module, excluding the "Risk Review" feature.</Text>
            <Text>RISK USER (READ-ONLY): Grants read-only access to the "Risk Management" module, excluding the "Risk Review" feature.</Text>
            <Text>THIRD-PARTY USER: Grants access to the "Third-Party Risk Management" module.</Text>
            <Text>THIRD-PARTY USER (READ-ONLY): Grants read-only access to the "Third-Party Risk Management" module.</Text>
            <div className={'modalFormButtonContainer'}>
                <Button variant="primary" onClick={() => props.hideModal()} fontAwesomeImage={ICON_CLOSE}>
                    Close
                </Button>
            </div>
        </Modal>
    );
};
